import {h, Fragment} from "preact"
import { isDesktop } from "../../helpers"

export default function ShowMoreFacetButton({active,toggleShowAll,showAll}) {
    return (
        <button class={`button-show-more link underlined-link no-js-hidden ns-show-more-facet ${active && isDesktop ? 'ns-d-inline-block' : 'ns-d-none'}`} type="button" onClick={toggleShowAll}>
            <span class={`label-show-more label-text ${!showAll ? '': 'hidden'}`}><span aria-hidden="true">+ </span>Show more</span>
            <span class={`label-show-less label-text ${!showAll ? 'hidden': ''}`}><span aria-hidden="true">- </span>Show less</span>
        </button>
    )
}